import { render, staticRenderFns } from "./SummeryNote.vue?vue&type=template&id=1c1c2164"
import script from "./SummeryNote.vue?vue&type=script&lang=js"
export * from "./SummeryNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports